var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c((_vm.name + "-icon"),{tag:"component",class:['c-icon', _vm.classes],attrs:{"fill":"currentColor","color":"currentColor"}})}
var staticRenderFns = []

export { render, staticRenderFns }